import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { t } from 'i18n-js';
import { isPhone } from '@helpers';
import MachinesGroupPopupBtn from './MachinesGroupPopupBtn';
import useManageMachinesGroupPopup from '@components/wallboard/hooks/useManageMachinesGroupPopup';

const MachinesGroupPopup = ({
  C,
  machines,
  getMachinesGroup,
  machinesGroup = [],
  machinesGroupLoaded,
  setIsPopupActive,
  setFilterMachinesByGroup,
  Svg,
  TouchableElement,
  width,
  filterMachinesByGroup,
  AnimatedTable,
  font,
  Button,
  navigateTo,
}) => {
  const { machinesGroupFormatted, selectGroup } = useManageMachinesGroupPopup({
    getMachinesGroup,
    machinesGroup,
    machines,
    setIsPopupActive,
    setFilterMachinesByGroup,
  });

  const selectedGroupName = machinesGroup.find((m) => m.machineGroupId == filterMachinesByGroup)?.name;

  return (
    <TouchableOpacity
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: C('Overlay/Light/Dim strong'),
        position: 'absolute',
      }}
      onPress={() => setIsPopupActive(false)}
    >
      <View
        style={{
          width: 760,
          position: 'absolute',
          right: 18,
          top: 43,
        }}
      >
        {isPhone && (
          <MachinesGroupPopupBtn
            {...{
              C,
              customStyle: { backgroundColor: C('Background/Light/Field lighter'), position: 'absolute', top: -34, right: 53 },
              setIsPopupActive,
              Svg,
              TouchableElement,
              name: selectedGroupName,
            }}
          />
        )}
        {machinesGroupFormatted?.length && machinesGroupLoaded ? (
          <View>
            <AnimatedTable
              {...{
                C,
                loaded: machinesGroupLoaded,
                array: machinesGroupFormatted,
                headerSize: 50,
                lineSize: 63,
                showMoreSize: 63,
                onPress: selectGroup,
                borderRadiusConfig: {
                  borderTopLeftRadius: 9,
                  borderTopRightRadius: 9,
                },
                config: [
                  {
                    key: 'name',
                    title: 'Department',
                    width: '30%',
                    color: C('Label / Light / Secondary'),
                    titleColor: C('Label / Light / Secondary'),
                  },
                  {
                    key: 'machinesList',
                    title: 'Machines',
                    width: '70%',
                    color: C('Label / Light / Secondary'),
                    titleColor: C('Label / Light / Secondary'),
                  },
                ],
              }}
            />
            <View
              style={{
                width: '100%',
                height: 54,
                backgroundColor: C('Background/Light/Field'),
                borderBottomLeftRadius: 9,
                borderBottomRightRadius: 9,
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                borderTopWidth: StyleSheet.hairlineWidth,
                borderTopColor: C('Hairline/Light/Secondary'),
              }}
            >
              <Button
                {...{
                  variant: 'M',
                  type: 'Secondary',
                  onPress: () => {
                    navigateTo('Settings', {
                      screen: 'Machines',
                      params: {
                        screen: 'MachinesScreen',
                        params: {
                          screen: 'MachinesGroup',
                        },
                      },
                    });
                  },
                }}
              >
                {t('Machine Group Settings')}
              </Button>
            </View>
          </View>
        ) : (
          <View
            style={[
              font.Body,
              {
                width: '100%',
                height: '70%',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                backgroundColor: C('Background/Light/Field'),
                paddingVertical: 20,
                borderRadius: 9,
              },
            ]}
          >
            {t('No groups available')}
          </View>
        )}
      </View>
      {!isPhone && (
        <View style={{ position: 'absolute', right: 18, top: 0, height: 43, justifyContent: 'center' }}>
          <MachinesGroupPopupBtn
            {...{
              C,
              customStyle: { backgroundColor: C('Background/Light/Field lighter') },
              setIsPopupActive,
              Svg,
              TouchableElement,
              name: selectedGroupName,
            }}
          />
        </View>
      )}
    </TouchableOpacity>
  );
};

export default MachinesGroupPopup;
